<!-- SelectedUsersAndGroupBadges.vue -->
<script lang="ts" setup>
    import { computed } from 'vue';
    import { IDatabaseIdModel } from '../../lib/Models/DatabaseIdModel';
    import { DisplayStyle, IconTypes } from '../../Enums/UiEnums';
    import { IntDatabaseIdAndNameModel } from '../../lib/Models/IntDatabaseIdAndNameModel';
    import { DatabaseIdTypes } from '../../Enums/ChoiceEnums';
    import MessageBadge from "../../components/Messages/MessageBadge.vue"
    import Icon from '../../components/Icon.vue'

    const props = withDefaults(defineProps<{
        usersAndGroups?: IntDatabaseIdAndNameModel[]    // All users/groups
        selectedUsersAndGroups?: IDatabaseIdModel[],    // Selected users/groups
        allSelectedText?: string,                       // Text to show when all possible users/groups are selected
        nothingSelectedText?: string,                   // Text to show when no users/groups are selected
        maxUniqueNames?: number                         // Maximum number of users/groups before showing the number of selections instead
    }>(), {
        allSelectedText: "All",
        nothingSelectedText: "None",
        maxUniqueNames: 5
    });

    const singularUsersAndGroupsSelectionText = computed<string|undefined>(() => {
        if (0 === (props.usersAndGroups?.length ?? 0))
        return;

        const selCnt = props.selectedUsersAndGroups?.length ?? 0;
        if (0 === selCnt)
            return props.nothingSelectedText;
        if (selCnt === props.usersAndGroups?.length)
            return props.allSelectedText;

        if (selCnt > props.maxUniqueNames)
            return `${selCnt} Users/Groups`;
    });

    function selectedItemInfo(selection: IDatabaseIdModel): IntDatabaseIdAndNameModel|undefined
    {
        return props.usersAndGroups?.find(item => item.id == selection.id && item.idType == selection.idType);
    }
</script>

<template>

    <MessageBadge v-if="singularUsersAndGroupsSelectionText">
        {{ singularUsersAndGroupsSelectionText }}
    </MessageBadge>

    <template v-if="selectedUsersAndGroups?.length && !singularUsersAndGroupsSelectionText">
        <template v-for="selectedItem of selectedUsersAndGroups.map(item => selectedItemInfo(item))">
            <MessageBadge class="me-1" v-if="selectedItem">
                <Icon :icon="IconTypes.User" :displayStyle="DisplayStyle.Warning" v-if="DatabaseIdTypes.user_id === selectedItem.idType" />
                <Icon :icon="IconTypes.Users" :displayStyle="DisplayStyle.Warning" v-if="DatabaseIdTypes.user_group_id === selectedItem.idType" />
                {{ selectedItem.name }}
            </MessageBadge>
        </template>
    </template>
</template>